<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: 100vh">
        <v-container fluid>
          <v-card>
            <v-card-text>
              <MenuCategoryEdit />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import MenuCategoryEdit from "@/components/MenuCategory/MenuCategoryEdit";

export default {
  components: {
    Navigation,
    MenuCategoryEdit,
  },
};
</script>
